import React from 'react';
import Markdown from 'react-markdown';

interface HyperlinkCustomizationProps {
	content: string | JSX.Element;
}

const hyperlinkStyle = {
	fontWeight: '300',
	cursor: 'pointer',
	textDecoration: 'underline',
	color: 'inherit'
};

const HyperlinkCustomization: React.FC<HyperlinkCustomizationProps> = ({ content }) => {
	const components = {
		a: ({ children, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
			const href = props.href;

			return (
				<a {...props} href={href} style={hyperlinkStyle}>
					{children}
				</a>
			);
		}
	};

	if (typeof content === 'string') {
		return (
			<Markdown className="custom-markdown" components={components}>
				{content}
			</Markdown>
		);
	} else {
		return <>{content}</>;
	}
};

export default HyperlinkCustomization;
